import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react"
import clsx from "clsx"
import BodyText from "components/Typography/BodyText"
import { memo } from "react"
import { FaEye, FaLayerGroup, FaList } from "react-icons/fa"
import { RiLayoutMasonryFill } from "react-icons/ri"
import styled from "styled-components"

const ActionHeaderOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 4px;

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`

interface ActionsHeaderProps {
  icon: JSX.Element
  title: string
  onClick: (() => void) | undefined
  disabled?: boolean
}

const ActionsHeader = (props: ActionsHeaderProps) => {
  const { icon, title, onClick, disabled } = props

  return (
    <>
      {title === "Formatação" && (
        <Menu key={title}>
          <MenuButton as="button">
            <ActionHeaderOption key={title} onClick={onClick}>
              <span>{icon}</span>
              <BodyText size="small" weight="bold">
                {title}
              </BodyText>
            </ActionHeaderOption>
          </MenuButton>
          <MenuList>
            <MenuItem icon={<RiLayoutMasonryFill />}>Marca texto</MenuItem>
            <MenuItem icon={<FaLayerGroup />}>Agregação</MenuItem>
            <MenuItem icon={<FaEye />}>Gráfico</MenuItem>
            <MenuItem icon={<FaList />}>Agrupamento</MenuItem>
          </MenuList>
        </Menu>
      )}

      {title !== "Formatação" && (
        <ActionHeaderOption className={clsx({ disabled })} key={title} onClick={onClick}>
          <span>{icon}</span>
          <BodyText size="small" weight="bold">
            {title}
          </BodyText>
        </ActionHeaderOption>
      )}
    </>
  )
}

export default memo(ActionsHeader)
